import { gql } from './apollo';

export const GET_TOKEN_BY_ID = gql`
    query ($token_id: MultiTypeInput!) {
        table(
            name: "eml_token"
            filter: [{ left: "external_id", right: $token_id, expression: "iLIKE" }]
            limit: 1
        )
    }
`;

export const REDEEM_EML_TOKEN = gql`
    mutation (
        $id: String!
        $redeem_center: MultiTypeInput
        $comment: MultiTypeInput
        $user_id: MultiTypeInput
        $date: MultiTypeInput
    ) {
        updateRow(
            table: "eml_token"
            id: $id
            values: [
                { property: "redeem", value: true }
                { property: "redeem_centre", value: $redeem_center }
                { property: "comment", value: $comment }
                { property: "user_id", value: $user_id }
                { property: "updated_at", value: $date }
            ]
        )
    }
`;
